export const DIFFERENT_ADDRESS_REMOVED_EVENT = 'differentAddress:removed';
